import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CreateUserPaymentDialogData,
  UserPaymentService,
} from '@x/ecommerce-shop/app/core/auth/services/user-payment.service';
import { IShopUserPaymentMethod } from '@x/ecommerce/shop-client';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'x-create-user-payment-dialog',
  templateUrl: './create-user-payment-dialog.component.html',
  styleUrls: ['./create-user-payment-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateUserPaymentDialogComponent implements OnInit {
  private _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CreateUserPaymentDialogData,
    private userPaymentService: UserPaymentService,
    private dialogRef: MatDialogRef<CreateUserPaymentDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.userPaymentService
      .startPollingPaymentState$(this.data.userPaymentMethod.id)
      .pipe(
        tap((userPaymentMethod) => {
          if (userPaymentMethod.state === 'PROCESSING') return;
          this.closeDialog(userPaymentMethod);
        }),
        takeUntil(this._destroy$),
        catchError((e) => {
          this.cancelPayment();
          return of(e);
        }),
      )
      .subscribe();
  }

  stopPolling() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  closeDialog(userPaymentMethod: IShopUserPaymentMethod = this.data.userPaymentMethod) {
    this.stopPolling();
    this.dialogRef.close(userPaymentMethod);
  }

  cancelPayment() {
    this.userPaymentService
      .cancelUserPaymentMethod$(this.data.userPaymentMethod.id)
      .pipe(
        tap(() => {
          this.stopPolling();
          this.dialogRef.close(null);
        }),
      )
      .subscribe();
  }
}
